<template>
  <v-container fluid class="user-settings py-4 py-sm-6">
    <list
      :hide-create="true"
      class="mb-5"
      @access-management="canManageAccess = $event"
    />
    <invite :can-manage-access="canManageAccess" />
  </v-container>
</template>
<script>
import List from "../components/List"
import Invite from "../components/Invite"

export default {
  name: "user-views-main",
  components: {
    List,
    Invite,
  },
  data() {
    return { canManageAccess: null };
  },
}
</script>

<style scoped>
.user-settings { max-width: 1180px; }
</style>
